import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import axios from "../../../axios";
import {getEventQuestions} from "./getEventQuestions";

export function useGetEventQuestions() {
  const {eventId} = useParams<{eventId: string}>();

  return useQuery({
    queryKey: ["order-questions", eventId],
    queryFn: async () => {
      if (!eventId) throw new Error("Event id is required");
      const response = await getEventQuestions(
        {data: {eventId: parseInt(eventId)}},
        axios
      );
      return response;
    },
    enabled: !!eventId,
    retry: false,
    throwOnError: true,
  });
}
